export var CATEGORIZATION_SLUG = 'categorization';
export var ESSAY_SLUG = 'essay';
export var FILE_UPLOAD_SLUG = 'file-upload';
export var FILL_BLANK_SLUG = 'fill-blank';
export var FORMULA_SLUG = 'formula';
export var HOT_SPOT_SLUG = 'hot-spot';
export var MATCHING_SLUG = 'matching';
export var MULTIPLE_ANSWER_SLUG = 'multi-answer';
export var MULTIPLE_CHOICE_SLUG = 'choice';
export var NUMERIC_SLUG = 'numeric';
export var ORDERING_SLUG = 'ordering';
export var RICH_FILL_BLANK_SLUG = 'rich-fill-blank';
export var TRUE_FALSE_SLUG = 'true-false';

// Interaction types that use typing to fill a response
export var KEYSTROKE_ENTRY_TYPES = [ESSAY_SLUG, FILL_BLANK_SLUG, FORMULA_SLUG, NUMERIC_SLUG, RICH_FILL_BLANK_SLUG];